module.exports = __webpack_public_path__ + "img/presion-2.227ffd58.svg";